import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import AboutSection from './components/AboutSection';
import ProjectsSection from './components/ProjectsSection';
import TestimonialsSection from './components/TestimonialsSection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import NewsletterSection from './components/NewsletterSection';

export default function HomePage() {
  useEffect(() => {
    // Inject Schema.org JSON-LD for HomePage
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yanginalgila.com';
    
    const schemaWebSite = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "YANGINALGILA.COM",
      "url": siteUrl,
      "description": "Güvenilir yangın algılama ve alarm sistemleri ile çalışanlarınızı koruyun ve işinize yönelik riskleri en aza indirin.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${siteUrl}/hizmetler?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    };

    const schemaLocalBusiness = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "YANGINALGILA.COM",
      "image": `${siteUrl}/og-image.jpg`,
      "url": siteUrl,
      "telephone": "+90-312-XXX-XXXX",
      "email": "info@yanginalgila.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Ankara",
        "addressLocality": "Ankara",
        "addressRegion": "Ankara",
        "postalCode": "06000",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 39.925533,
        "longitude": 32.866287
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      ],
      "priceRange": "$$",
      "description": "Yangın algılama sistemleri, duman sensörleri ve yangın alarm sistemleri konusunda uzman çözümler sunuyoruz."
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(schemaWebSite);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(schemaLocalBusiness);
    document.head.appendChild(script2);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return (
    <main>
      <h1 className="sr-only">Yangın Algılama ve Yangın Alarm Sistemleri - YANGINALGILA.COM</h1>
      <HeroSection />
      <ServicesOverview />
      <AboutSection />
      <ProjectsSection />
      <TestimonialsSection />
      <StatsSection />
      <CTASection />
      <ContactSection />
      <NewsletterSection />
    </main>
  );
}